/**
 * Represents the format used for date strings.
 * The format follows the structure 'dd-MM-yyyy',
 * where:
 * - 'dd' corresponds to the two-digit day of the month (01-31).
 * - 'MM' corresponds to the two-digit month (01-12).
 * - 'yyyy' corresponds to the four-digit year.
 */
export const DATE_FORMAT = 'dd-MM-yyyy';
